var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8484 54.9117L31.8485 54.9117L57.8526 28.9076C58.9309 27.8293 58.9309 26.0809 57.8526 25.0027L54.6548 21.8049C54.6548 21.8049 54.6548 21.8049 54.6548 21.8049C53.5765 20.7264 51.8281 20.7265 50.7497 21.8049L29.896 42.6585L20.3483 33.1109C19.27 32.0326 17.5217 32.0326 16.4433 33.1108L16.4433 33.1109L13.2455 36.3087C12.1672 37.3869 12.1672 39.1353 13.2455 40.2136L27.9434 54.9115C29.0218 55.9899 30.77 55.9899 31.8484 54.9117ZM70.098 35.9999C70.098 55.0809 54.63 70.549 35.549 70.549C16.4681 70.549 1 55.0809 1 35.9999C1 16.919 16.4681 1.45093 35.549 1.45093C54.63 1.45093 70.098 16.919 70.098 35.9999Z",
    fill: "#4ADE80",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.a3a01c6ae423a7aa6099946605f4f50d.svg";
export { ForwardRef as ReactComponent };